/* eslint-disable @typescript-eslint/no-explicit-any */

export const invalidateAllTagsOnSignInMiddleware =
  (apis: any[]) => (store: any) => (next: any) => (action: any) => {
    if (action.type === "auth/userLoggedIn") {
      apis.forEach((api) => {
        store.dispatch(api?.util?.resetApiState());
      });
    }
    return next(action);
  };
